import template from './tdcp-customer-price-detail.html.twig';

Shopware.Component.register('tdcp-customer-price-detail', {
    template,

    inject: ['repositoryFactory', 'acl'],

    data() {
        return {
            item: null,
            isLoading: false,
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle(),
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdcp_price');
        },

        priceId() {
            return this.$route.params.id;
        },

        graduatedPriceColumns() {
            return [{
                property: 'quantityStart',
                label: this.$tc('tdcp-customer-prices.detail.label.graduatedPriceQuantity'),
                allowResize: true,
            }, {
                property: 'price',
                label: this.$tc('tdcp-customer-prices.detail.label.graduatedPriceValue'),
                allowResize: true,
            }];
        },
    },

    created() {
        this.loadEntity();
    },

    methods: {
        loadEntity() {
            this.isLoading = true;
            const criteria = new Shopware.Data.Criteria();
            criteria.addAssociation('product');
            criteria.addAssociation('customer');
            criteria.addAssociation('graduatedPrices');

            this.repository.get(this.priceId, Shopware.Context.api, criteria).then((result) => {
                this.item = result;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        formatPrice(price) {
            if (!price || !price.length) {
                return '-';
            }
            const currencyPrice = price[0];
            const gross = currencyPrice.gross;
            const net = currencyPrice.net;
            const currencySymbol = currencyPrice.currency?.symbol || 'EUR';

            return `${currencySymbol} ${gross.toFixed(2)} gross / ${net.toFixed(2)} net`;
        },

        formatGraduatedPrice(price) {
            if (!price || !price.length) {
                return '-';
            }
            const currencyPrice = price[0];
            const gross = currencyPrice.gross;
            const currencySymbol = currencyPrice.currency?.symbol || 'EUR';

            return `${currencySymbol} ${gross.toFixed(2)}`;
        },

        onBack() {
            this.$router.push({ name: 'tdcp.customer.prices.list' });
        },
    },
});
